/* Component in Accountpage to display the Profile and Account data
 * Contains the CreateProject and Projects components test push */
import React, { useState } from "react";
import btnStyles from "../../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../../styles/Account.module.css";
import { Image } from "react-bootstrap";
import { ProfileEditDropdown } from "../../components/UniDropDown";
import Projects from "./Projects";
import { useHistory } from "react-router-dom";
import useActivePlan from "../../hooks/useActivePlan";
import { hasBudgetPlan } from "../../utils/hasBudgetPlan";
import toast from "react-hot-toast";
import InfoAcc from "./InfoAcc";

const Account = ({
  id,
  profile,
  account,
  stripeCategoryType,
  stripeProjectName,
  stripeSessionId,
  stripeSuccess,
  profileInfo,
}) => {
  const history = useHistory();
  const [showImp, setShowImp] = useState(false);

  const topProfile = (
    <div className={`${styles.Top}`}>
      <Row className="py-2 d-flex align-items-center">
        <Col md={3}>
          <Image
            className={`${styles.Avatar}`}
            height={50}
            width={50}
            src={profileInfo?.data?.image}
          />
        </Col>
        <Col md={6} className="text-center">
          <h3 className={` ${styles.TopName2}`}>
            ACCOUNT PAGE
          </h3>
          <h5 className={`pt-3 ${styles.TopCompany}`}>
            {account?.data?.results[0]?.name} - {account?.data?.results[0]?.company}
          </h5>
        </Col>
        <Col md={3} className="d-flex align-items-center">
          <ProfileEditDropdown id={id} />
        </Col>
      </Row>
    </div>
  );

  const topProfileMo = (
    <div className={`${styles.Top} text-center`}>
      <Row className="d-flex align-items-center py-1">
        <Col xs={2} className="d-flex align-items-center" >
          <Image
            className={`${styles.Avatar}`}
            height={30}
            width={30}
            src={profileInfo?.data?.image}
          />
        </Col>
        <Col xs={8}>
          <h5 className={` ${styles.TopName2}`}>
            ACCOUNT PAGE
          </h5>
        </Col>
        <Col xs={2} className="d-flex align-items-center">
          <ProfileEditDropdown id={id} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3 className={`pt-3 ${styles.TopCompany}`}>
            {account?.data?.results[0]?.name} - {account?.data?.results[0]?.company}
          </h3>
        </Col>
      </Row>
    </div>
  );

  const accountInfo = (
    <div className="px-3">
      <Row>
        <Col className="my-2">
          <p className={`${styles.SmallSize} float-right ml-3`}>
            Account Created: {account?.data?.results[0].created_at}
          </p>
          <p className={`${styles.SmallSize} float-right`}>
            Account Owner: {account?.data?.results[0].owner}
          </p>
        </Col>
      </Row>
    </div>
  );
  const { currentlyActivePlans } = useActivePlan();

  const handleShowBudget = () => {
    if (!hasBudgetPlan(currentlyActivePlans)) {
      toast.error(`You don't have any active packages!`);
      history.push(`/subscription-plans`);
      return;
    }

    // history.push(`/profiles/${userData?.pk}`);
    history.push("/my-budgets");
    // setShowCreateProject((showCreateProject) => !showCreateProject);
  };
  return (
    <div className="px-3">
      <div className="d-none d-md-block">{topProfile}</div>
      <div className="d-block d-md-none">{topProfileMo}</div>
      {/* back button */}
      <Row className="mt-1">
        <Col xs={6} className="">
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue}`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        <Col xs={6} >
          <Button
            className={`float-right px-3 ${btnStyles.Button} ${btnStyles.Order}`}
            onClick={() => setShowImp(showImp => !showImp)}
          >INFO
          </Button>
        </Col>
      </Row>
      {!showImp ? (
        ""
      ) : (
        <InfoAcc />
      )}
      {/* budgets */}
      <Row className="mb-3">
        <Col md={6} className="text-center">
        <p className={`${styles.SmallSize} mb-0`}>
            Click here to go to the Budget Only page
          </p>
          <div className="mt-2">
          <Button
            className={`px-5 ${btnStyles.Button} ${btnStyles.Track}`}
            onClick={handleShowBudget}
          >BUDGETS
          </Button>
          </div>
        </Col>
        <Col md={6} className="text-center">
        <p className={`${styles.SmallSize} mb-0`}>
            Click here to Update Billing Details
          </p>
          <div className="mt-2">
            <Button
              className={`${btnStyles.Button} ${btnStyles.Track}`}
              onClick={() => history.push("/account/billing")}
            >
              PAYMENT METHODS
            </Button>
          </div>
        </Col>
      </Row>
      {/* <Link className={styles.Link} to="/terms-and-conditions">
      Terms of Service
      </Link> */}
      {/* <Form.Group controlId="termsConditions">
        <Form.Check
          type="checkbox"
          label={
            <>
              I accept the{" "}
              <Link className={styles.Link} to="/terms-and-conditions">
                Terms of Service
              </Link> */}
              {/* <a
                          href="/terms-and-conditions"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms of Service
                        </a> */}
            {/* </>
          }
        />
      </Form.Group> */}
      <Row className="px-3">
        <Col className="text-center">
          <h3 className={`mt-1 py-1 text-center ${styles.SubTitle4}`}
          >PLATFORM PROJECTS
          </h3>
          {/* <h3 className="mt-2">PROJECTS</h3>
        <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Projects
            id={id}
            stripeCategoryType={stripeCategoryType}
            stripeProjectName={stripeProjectName}
            stripeSessionId={stripeSessionId}
            stripeSuccess={stripeSuccess}
          />
        </Col>
      </Row>
      {accountInfo}
    </div>
  );
};

export default Account;
